// Colocadores de licitaciones (ver docs/ingresos-licitaciones.md).

// CUIT de Axon Capital S.A. Cuando Axon es uno de los colocadores de una licitación, el
// fee lo paga la emisora y la licitación exige su CUIT. Es el mismo valor que
// `axonCuit()` en firestore.rules y AXON_CUIT en functions/ingresosLicitaciones.js:
// cambiar los tres juntos.
export const AXON_CUIT = '30718822455';

// Tope de colocadores por licitación. Las reglas de Firestore no recorren listas: validan
// posición por posición hasta este máximo (colocadoresValidos en firestore.rules).
// Cambiar los dos juntos.
export const MAX_COLOCADORES_POR_LICITACION = 6;

// Tope de las reglas de Firestore: 10.000 bps = 100 % del monto adjudicado.
export const FEE_MAX_BPS = 10000;
